import jwtDecode from 'jwt-decode';

const API_URL = window.env ? window.env.API_SERVER : '';
const graphToken = 'GRAPH_ID_TOKEN';
const idToken = 'LIS_ID_TOKEN';
const refreshToken = 'LIS_REFRESH_TOKEN';
const refreshTokenExpiration = 'LIS_REFRESH_TOKEN_EXPIRATION';
const claims = "LIS_CLAIMS";
const accessTokenExpiration = 'LIS_ACCESS_TOKEN_EXPIRATION';

const logoutRequest = 'LOGOUT_REQUEST';
const logoutSuccess = 'LOGOUT_SUCCESS';

const refreshTokenRequest = 'REFRESH_TOKEN_REQUEST';
const refreshTokenSuccess = 'REFRESH_TOKEN_SUCCESS';
const refreshTokenFailure = 'REFRESH_TOKEN_FAILURE';

const houseLoginRequest = 'HOUSE_ACCESS_TOKEN_REQUEST';
const houseLoginSuccess = 'HOUSE_ACCESS_TOKEN_SUCCESS';
const houseLoginFailure = 'HOUSE_ACCESS_TOKEN_FAILURE';

const newLoginRequest = 'NEW_ACCESS_TOKEN_REQUEST';
const newLoginSuccess = 'NEW_ACCESS_TOKEN_SUCCESS';
const newLoginFailure = 'NEW_ACCESS_TOKEN_FAILURE';

const authPromises = {}

const decodedToken = () => {
    const jwtToken = localStorage.getItem(idToken);

    const userData = {
        initials: '',
        name: '',
        chamber: '',
        email: '',
        claims: [],
        roles: [],
        scopes: [],
        resources: []
    };

    if (jwtToken !== null && jwtToken !== 'undefined') {
        const decode = jwtDecode(jwtToken);
        const stringToken = JSON.stringify(decode);
        const parsedToken = JSON.parse(stringToken);
        userData.initials = parsedToken.given_name.charAt(0) + parsedToken.family_name.charAt(0);
        userData.name = parsedToken.given_name + ' ' + parsedToken.family_name;
        userData.expr = parsedToken.exp;
        userData.email = parsedToken.email
    }
    return userData;
}

const isTokenExpired = () => {
    const jwtToken = localStorage.getItem(idToken);

    var expr = '';

    if (jwtToken !== null && jwtToken !== 'undefined') {
        const decode = jwtDecode(jwtToken);
        const stringToken = JSON.stringify(decode);
        const parsedToken = JSON.parse(stringToken);

        expr = parsedToken.exp;
        return expr < new Date().getTime() / 1000;
    } else {
        return true;
    }
}

const parsedClaims = () => {
    const claimsObject = JSON.parse(localStorage.getItem(claims));

    let userClaims = {
        scopes: [],
        roles: [],
        resources: [],
        claims: []
    };

    if (claimsObject)
        for (let i = 0; i < claimsObject.length; i++) {
            userClaims.scopes.push(claimsObject[i].Scope)
            userClaims.roles.push(claimsObject[i].RoleName)
            userClaims.resources.push(claimsObject[i].Resource)
            userClaims.claims.push(claimsObject[i])
        }

    return userClaims;
}

export const authActionCreators = {

    // LOGOUT THE USER

    requestLogout: () => ({
        type: logoutRequest,
        isFetching: true,
        initiateRedirect: false,
        isAuthenticated: true
    }),

    receiveLogout: () => ({
        type: logoutSuccess,
        isFetching: false,
        initiateRedirect: false,
        isAuthenticated: false,
        userProfile: false,
        userClaims: false
    }),

    logoutUser: () => {
        return dispatch => {
            dispatch(authActionCreators.requestLogout());
            localStorage.removeItem(idToken);
            localStorage.removeItem(refreshToken);
            localStorage.removeItem(refreshTokenExpiration);
            localStorage.removeItem(accessTokenExpiration);
            localStorage.removeItem(claims);
            localStorage.removeItem(graphToken);
            dispatch(authActionCreators.receiveLogout())
        }
    },

    // RERESH ACCESS TOKEN

    requestRefreshToken: () => ({
        type: refreshTokenRequest,
        isFetching: true
    }),

    receiveRefreshToken: (user) => ({
        type: refreshTokenSuccess,
        isFetching: false,
        userProfile: decodedToken(user.AccessToken),
        userClaims: parsedClaims(),
        isTokenExpired: isTokenExpired(user.AccessToken)
    }),

    refreshTokenError: (message) => ({
        type: refreshTokenFailure,
        message
    }),

    refreshAccessToken: () => {
        let rtoken = localStorage.getItem(refreshToken);

        let config = {
            method: 'POST',
            headers: {
                "authorization": rtoken,
                "content-type": "application/json; charset=utf-8",
                "WebAPIKey": process.env.REACT_APP_API_KEY
            }
        }

        return dispatch => {
            // dispatch requestLogin and kickoff the call to the API
            dispatch(authActionCreators.requestRefreshToken());

            return fetch((API_URL || process.env.REACT_APP_AUTH_API_URL) + '/Authentication/api/RefreshAccessTokenAsync', config)
                .then(response => {
                    if (response.status > 399) {
                        dispatch(authActionCreators.refreshTokenError(response));
                        return Promise.reject(response);
                    }
                    return response
                })
                .then(response =>
                    response.json().then(user => ({ user, response }))
                ).then(({ user, response }) => {
                    // If refresh was successful, set the tokens in local storage
                    let roles = [];
                    if (user.Claims && user.Claims.Roles) {
                        roles = user.Claims.Roles;
                    }
                    localStorage.setItem(claims, JSON.stringify(roles));
                    localStorage.setItem(idToken, user.AccessToken);
                    localStorage.setItem(refreshToken, user.RefreshToken);
                    //604800000 is 7 days in milliseconds
                    localStorage.setItem(refreshTokenExpiration, new Date().getTime() + 604800000);
                    // Dispatch the success action
                    dispatch(authActionCreators.receiveRefreshToken(user))
                }).catch(err => console.log("Error: ", err))
        }
    },

    requestHouseLogin: () => ({
        type: houseLoginRequest,
        isFetching: true
    }),

    receiveHouseLogin: (user) => ({
        type: houseLoginSuccess,
        isFetching: false,
        initiateRedirect: true,
        isAuthenticated: true,
        isTokenExpired: isTokenExpired(user.AccessToken),
        userProfile: decodedToken(user.AccessToken),
        userClaims: parsedClaims()
    }),

    houseLoginFailure: (message) => ({
        isFetching: false,
        type: houseLoginFailure,
        message
    }),

    houseLogin: (authToken, refreshToken, expirationDate) => {
        let config = {
            method: 'POST',
            headers: { "Content-Type": "application/json; charset=utf-8", "WebAPIKey": process.env.REACT_APP_API_KEY },
        }

        return dispatch => {
            dispatch(authActionCreators.requestHouseLogin());
            //return fetch('http://localhost:61060' + '/Authentication/api/GetAccessTokenAsync?accesstoken=' + authToken, config)
            return fetch((API_URL || process.env.REACT_APP_AUTH_API_URL) + '/Authentication/api/GetAccessTokenAsync?accesstoken=' + authToken, config)
                .then(response =>
                    response.json().then(user => ({ user, response }))
                ).then(({ user, response }) => {
                    if (response.status >= 400) {
                        dispatch(authActionCreators.houseLoginFailure(user.FailureMessage))
                        return Promise.reject(user)
                    } else {
                        let roles = [];
                        if (user.Claims && user.Claims.Roles) {
                            roles = user.Claims.Roles;
                        }
                        localStorage.setItem(claims, JSON.stringify(roles));
                        localStorage.setItem(idToken, user.AccessToken);
                        localStorage.setItem(refreshToken, refreshToken);
                        localStorage.setItem(graphToken, user.GraphToken);
                        localStorage.setItem(refreshTokenExpiration, expirationDate.getTime() + 604800000);

                        dispatch(authActionCreators.receiveHouseLogin(user))
                    }
                }).catch(err => Promise.reject(err))
        }
    },

    requestNewLogin: () => ({
        type: newLoginRequest,
        isFetching: true
    }),

    receiveNewLogin: (user) => ({
        type: newLoginSuccess,
        isFetching: false,
        initiateRedirect: true,
        isAuthenticated: true,
        isTokenExpired: isTokenExpired(user.AccessToken),
        userProfile: decodedToken(user.AccessToken),
        userClaims: parsedClaims()
    }),

    newLoginFailure: (message) => ({
        isFetching: false,
        type: newLoginFailure,
        message
    }),

    newLogin: (authToken, expirationDate) => {
        let config = {
            method: 'POST',
            headers: { "Content-Type": "application/json; charset=utf-8", "WebAPIKey": process.env.REACT_APP_API_KEY },
        }

        return dispatch => {
            if (authPromises['newLogin']) {
                return authPromises['newLogin'];
            }
            dispatch(authActionCreators.requestNewLogin());
            //authPromises['newLogin'] =  fetch('http://localhost:61060' + '/Authentication/api/GetAccessTokenAsync?accesstoken=' + authToken, config)
            authPromises['newLogin'] = fetch((API_URL || process.env.REACT_APP_AUTH_API_URL) + '/Authentication/api/GetAccessTokenAsync?accesstoken=' + authToken, config)
                .then(response => response.json().then(user => ({ user, response }))
                ).then(({ user, response }) => {
                    if (response.status >= 400) {
                        dispatch(authActionCreators.newLoginFailure(user.FailureMessage))
                        return Promise.reject(user)
                    } else {
                        let roles = [];
                        if (user.Claims && user.Claims.Roles) {
                            roles = user.Claims.Roles;
                        }
                        localStorage.setItem(claims, JSON.stringify(roles));
                        localStorage.setItem(idToken, user.AccessToken);
                        localStorage.setItem(graphToken, user.GraphToken);
                        const decoded = jwtDecode(user.AccessToken);
                        localStorage.setItem(accessTokenExpiration, String(decoded.exp * 1000));
                        dispatch(authActionCreators.receiveNewLogin(user))
                    }
                }).catch(err => {
                    dispatch(authActionCreators.newLoginFailure(err?.FailureMessage || err?.message || 'New login failed'));
                    throw err;
                })
                .finally(() => {
                    delete authPromises['newLogin'];
                });

            return authPromises['newLogin'];
        }
    }
};

export const reducer = (state, action) => {

    state = {
        ...state,
        isFetching: false,
        initiateRedirect: false,
        isAuthenticated: isTokenExpired() ? false : true,
        userProfile: decodedToken(),
        userClaims: parsedClaims(),
        isTokenExpired: isTokenExpired()
    }

    switch (action.type) {
        case refreshTokenRequest:
            return Object.assign({}, state, {
                isFetching: true
            })
        case refreshTokenSuccess:
            return Object.assign({}, state, {
                isFetching: false,
                userProfile: action.userProfile,
                userClaims: action.userClaims,
                isTokenExpired: action.isTokenExpired,
                errorMessage: ''
            })
        case refreshTokenFailure:
            return Object.assign({}, state, {
                isFetching: false,
                initiateRedirect: false,
                isAuthenticated: false,
                errorMessage: action.message
            })
        case logoutSuccess:
            return Object.assign({}, state, {
                isFetching: true,
                initiateRedirect: false,
                isAuthenticated: false
            })
        case houseLoginRequest:
            return Object.assign({}, state, {
                isFetching: true,
                initiateRedirect: false
            })
        case houseLoginFailure:
            return Object.assign({}, state, {
                isFetching: false,
                initiateRedirect: false,
                isAuthenticated: false,
                errorMessage: action.message
            })
        case houseLoginSuccess:
            return Object.assign({}, state, {
                isFetching: false,
                initiateRedirect: true,
                isAuthenticated: true,
                errorMessage: '',
                userProfile: action.userProfile,
                userClaims: action.userClaims,
                isTokenExpired: action.isTokenExpired
            })
        case newLoginRequest:
            return Object.assign({}, state, {
                isFetching: true,
                initiateRedirect: false
            })
        case newLoginFailure:
            return Object.assign({}, state, {
                isFetching: false,
                initiateRedirect: false,
                isAuthenticated: false,
                errorMessage: action.message
            })
        case newLoginSuccess:
            return Object.assign({}, state, {
                isFetching: false,
                initiateRedirect: true,
                isAuthenticated: true,
                errorMessage: '',
                userProfile: action.userProfile,
                userClaims: action.userClaims,
                isTokenExpired: action.isTokenExpired
            })
        default:
            return state
    }
};
